import { toast, ToastContent, ToastOptions } from 'react-toastify'

export function toasty(content: ToastContent, options?: ToastOptions) {
  return toast(content, {
    ...options,
    containerId: 'for-all',
  })
}

export function toasted(content: ToastContent, options?: ToastOptions) {
  toast.dismiss('for-all')
  return toasty(content, options)
}
